const THEME_KEY = 'hc-theme';
const DARK = 'dark';
const LIGHT = 'light';
const SWITCH_MS = 400;

const root = document.documentElement;

function setTheme(theme) {
  root.setAttribute('data-theme', theme);
  const moonIcon = document.querySelector('#theme-btn .icon-moon');
  const sunIcon = document.querySelector('#theme-btn .icon-sun');
  if (!moonIcon || !sunIcon) return;
  moonIcon.style.display = theme === LIGHT ? 'none' : 'block';
  sunIcon.style.display = theme === LIGHT ? 'block' : 'none';
}

export function init() {
  const themeBtn = document.getElementById('theme-btn');

  setTheme(root.getAttribute('data-theme') || DARK);

  let switchTimer;
  themeBtn?.addEventListener('click', () => {
    const next = root.getAttribute('data-theme') === DARK ? LIGHT : DARK;
    clearTimeout(switchTimer);
    root.classList.add('switching');
    switchTimer = setTimeout(() => root.classList.remove('switching'), SWITCH_MS);
    localStorage.setItem(THEME_KEY, next);
    setTheme(next);
  });

  window.matchMedia('(prefers-color-scheme: light)').addEventListener('change', e => {
    if (localStorage.getItem(THEME_KEY)) return;
    setTheme(e.matches ? LIGHT : DARK);
  });
}
